import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import vClickOutside from 'v-click-outside';
import GAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

Vue.config.productionTip = false;

const toastOptions = {};
Vue.use(Toast, toastOptions)

Vue.use(vClickOutside)

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
});

if (window.Cypress) {
  window.app = app;
}
app.$mount('#app');
